export const isInteger = (value: any) => {
  if (!value) {
    return undefined;
  }

  return /^-?\d*$/.test(value) ? undefined : 'Must be number';
};
